/* eslint-disable */

import Vue from "vue";
import config from '../../config'

const reporter = {
    socket: null,
    reporterChanel: null,
    init: function () {
        Vue.ws.disconnect()
        Vue.ws.connect(
            {
                wsDomain: config.wsDomain,
            },
            {
                path: config.wsPath,
                reconnectionAttempts: 300,
                reconnectionDelay: 5000
            }
        )
        
        this.socket = Vue.ws

        this.reporterChanel = this.socket.subscribe('reporter')

        Vue.config.errorHandler = function (e, vm, info) {
            console.error(e)
            reporter.event('VUE_ERROR', info + ', ' + JSON.stringify({
                message: e.message,
                stack: e.stack
            }));
        }
        Vue.config.warnHandler = function (e, vm, info) {
            console.warn(e)
            reporter.event('VUE_WARN', info + ', ' + JSON.stringify({
                message: e.message,
                stack: e.stack
            }));
        }

        return this
         
    },
    event: function (eventCode, message) {

        if (this.reporterChanel.state == 'open') {

            const tracking = localStorage.getItem('_speakup_track') ?? ''
            const location = window.location

            this.reporterChanel.emit('error', {
                eventCode: eventCode,
                message: message,
                tracking,
                href: location.href
            })
        }
        // const isReady = this.socket && this.socket.readyState === WebSocket.OPEN;
        // if (isReady) { // Messages triggered before the WebSocket is ready are ignored
        //     this.socket.$emitToServer(JSON.stringify({eventCode: eventCode, message: message}));
        // }
    },
}

window.reporter = reporter

// Start reporter immediately
export default reporter


window.addEventListener('error', function (e) {
    console.log(e)

    reporter.event('JAVASCRIPT_ERROR', e.message + ', ' + e.filename + ', ' + e.lineno + ':' + e.colno);
    
    let stacktrace = e.stack;
    if (!stacktrace && e.error) {
        stacktrace = e.error.stack;
    }
    if (stacktrace) {
        reporter.event('JAVASCRIPT_ERROR_STACKTRACE', stacktrace);
    }

});

window.addEventListener('unhandledrejection', function(e) {

    const errorReport = {
        reason: e?.reason,
    }
    reporter.event('JAVASCRIPT_UNHANDLED', JSON.stringify(errorReport));

});